import { Divider, HStack, Spacer, Text, VStack } from "@chakra-ui/react";
import { UserFragment } from "gql/graphql";
import React, { memo, useMemo } from "react";
import colors from "app/colors";
import { useDistributionGroups } from "modules/providers/distribution-groups-provider";
import DistributionGroupName from "modules/_shared/distribution-group-name";
import DistributionGroupTooltip from "modules/_shared/distribution-group-tooltip";
import { sortByName } from "modules/utils/Functions";
import DistributionGroupInboxIndicator from "modules/drawers/components/user-profile/distribution-group-inbox-indicator";

interface IProps {
  user: UserFragment;
}

const UserDistributionGroups = ({ user }: IProps) => {
  const { distributionGroups } = useDistributionGroups();

  const distributionGroupList = useMemo(
    () =>
      distributionGroups
        .filter((obj) => obj.userIdList.includes(user.id))
        .sort(sortByName),
    [user.id, distributionGroups],
  );

  return (
    <VStack w="full" alignItems="flex-start">
      {distributionGroupList.map((distributionGroup) => (
        <React.Fragment key={distributionGroup.id}>
          <HStack w="full">
            <DistributionGroupTooltip id={distributionGroup.id}>
              <Text
                color={
                  distributionGroup.active ? colors.blue : colors.grayPrimary
                }
              >
                <DistributionGroupName
                  distributionGroupId={distributionGroup.id}
                />
              </Text>
            </DistributionGroupTooltip>
            <Spacer />
            <DistributionGroupInboxIndicator
              distributionGroup={distributionGroup}
              userId={user.id}
            />
          </HStack>
          <Divider />
        </React.Fragment>
      ))}
    </VStack>
  );
};

export default memo(UserDistributionGroups);
